let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("bXcCM"), load("ffEVr"), load("7EorR"), load("hhss7"), load("67Pvd")]).then(() => parcelRequire('6IU81'));